export function navigation() {
	// Nur bei vorhandenem Aufklapp-Menü (entspricht Twig: navSite is not null)
	var navSite = document.querySelector('.nav__site')
	if (!navSite) {
		return
	}

	var siteHeader = document.querySelector('.site__header')
	if (!siteHeader) {
		return
	}

	// Innerhalb dieser Distanz zum Seitenanfang (px): nav-down und wasHidden zurücksetzen → kein Hintergrund
	var TOP_THRESHOLD = 200

	// Wurde die Navigation mindestens einmal via nav-up versteckt? (Voraussetzung für nav-down)
	var wasHidden = false

	// Erste Sektion kein Banner → sofort Hintergrund setzen; TOP_THRESHOLD-Reset greift dann nicht.
	var firstSection = document.querySelector('.site__content section:first-child')
	var startsWithBanner = !!(firstSection && (
		firstSection.classList.contains('section--banner') ||
		firstSection.classList.contains('section--parallax')
	))
	// Intro-Heading in Parallax-Sektionen synchron zur Navigation ein-/ausblenden
	var parallaxIntro = document.querySelector('.section--parallax:first-child .xgallery__intro')

	if (!startsWithBanner) {
		siteHeader.classList.add('nav-down')
		wasHidden = true
	}

	function toggleMenu() {
		var body = document.querySelector('body')
		var nav__button = document.querySelector('.nav__menu')

		if (body.classList.contains('js-nav-open')) {
			body.classList.remove('js-nav-open')
			nav__button.classList.remove('is-active')
		} else {
			body.classList.add('js-nav-open')
			nav__button.classList.add('is-active')
		}
	}

	document.querySelectorAll('.js-nav__menu').forEach((item) => item.addEventListener('click', toggleMenu))
	document.querySelectorAll('.nav__site li:not(.has-children)').forEach((item) => item.addEventListener('click', toggleMenu))


	// Ablauf Banner-Seiten:
	// 1. Oben → kein Hintergrund
	// 2. Runterscrollen (> 50vh) → nav-up: Header verschwindet, wasHidden = true
	// 3. Hochscrollen → nav-up weg; weil wasHidden, wird nav-down gesetzt (Hintergrund)
	// 4. Ganz nach oben (≤ TOP_THRESHOLD) → nav-down weg, wasHidden = false
	// Ablauf ohne Banner:
	// startsWithBanner = false → nav-down sofort gesetzt, wasHidden = true
	// TOP_THRESHOLD-Reset ignoriert da !startsWithBanner → Hintergrund bleibt

	var didScroll
	var lastScrollTop = 0
	var delta = 20

	document.addEventListener('scroll', function () {
		didScroll = true
	})

	function getScrollTop() {
		if (window.scrollY != null) {
			return window.scrollY
		}
		var se = document.scrollingElement
		return se ? se.scrollTop : (document.documentElement || document.body).scrollTop || 0
	}

	setInterval(function () {
		if (didScroll) {
			var menuBtn = document.querySelector('.nav__menu')
			if (menuBtn && !menuBtn.classList.contains('is-active')) {
				hasScrolled()
			}
			didScroll = false
		}
	}, 250)

	function hasScrolled() {
		var st = getScrollTop()

		// Ganz oben → nur bei Banner-Seiten reset (ohne Banner bleibt Hintergrund immer)
		if (st <= TOP_THRESHOLD && startsWithBanner) {
			siteHeader.classList.remove('nav-up')
			siteHeader.classList.remove('nav-down')
			if (parallaxIntro) parallaxIntro.classList.remove('is-scrolled')
			wasHidden = false
			lastScrollTop = st
			return
		}

		// Nicht genug bewegt → ignorieren
		if (Math.abs(lastScrollTop - st) <= delta) {
			return
		}

		if (st > lastScrollTop && st > window.innerHeight / 2) {
			// Runterscrollen: Header verstecken
			siteHeader.classList.remove('nav-down')
			siteHeader.classList.add('nav-up')
			if (parallaxIntro) parallaxIntro.classList.add('is-scrolled')
			wasHidden = true
		} else {
			// Hochscrollen: Header zeigen — Hintergrund nur wenn vorher versteckt
			siteHeader.classList.remove('nav-up')
			if (parallaxIntro) parallaxIntro.classList.remove('is-scrolled')
			if (wasHidden) {
				siteHeader.classList.add('nav-down')
			}
		}

		lastScrollTop = st
	}

	// Add ESC key handler
	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape') {
			const body = document.querySelector('body')
			const navMenuBtn = document.querySelector('.nav__menu')

			if (body.classList.contains('js-nav-open') && navMenuBtn) {
				body.classList.remove('js-nav-open')
				navMenuBtn.classList.remove('is-active')
			}
		}
	});
}
